<template>
    <div class="step7">
        <h1>Aanvraagformulier</h1>
        <h2>Uitgaven per maand</h2>

        <application-stepper current-step="7" :loading="!loaded">
            <h3>Uitgaven</h3>

            <v-form @submit.prevent="submit">
                <v-error-messages ref="errorMessages" :messages="this.errorMessages"></v-error-messages>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.rentMortgageAmount"
                            prefix="€"
                            label="Huur / hypotheek"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.cityTaxAmount"
                            prefix="€"
                            label="Gemeente belastingen"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.purificationChargesAmount"
                            prefix="€"
                            label="Zuiveringslasten (BSR)"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.utilitiesAmount"
                            prefix="€"
                            label="Energie (gas/elektra)"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field v-model="applicant.expense.waterAmount" prefix="€" label="Water"></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.healthInsuranceAmount"
                            prefix="€"
                            label="Zorgverzekering"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.householdInsuranceAmount"
                            prefix="€"
                            label="Inboedelverzekering"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.liabilityInsuranceAmount"
                            prefix="€"
                            label="WA verzekering"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.funeralInsuranceAmount"
                            prefix="€"
                            label="Uitvaartverzekering"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.internetTvPhoneAmount"
                            prefix="€"
                            label="Internet / TV / Telefoon"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.mobilePhoneAmount"
                            prefix="€"
                            label="Mobiele telefoon"
                        ></v-float-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-float-field
                            v-model="applicant.expense.otherAmount"
                            prefix="€"
                            label="Overig"
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6" offset-sm="6">
                        <v-float-field
                            v-model="applicantExpenseTotalAmount"
                            prefix="€"
                            label="Totaal"
                            readonly
                        ></v-float-field>
                    </v-col>
                </v-row>

                <v-row>
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="back" :loading="backBtnClicked" :disabled="submitting">Vorige</v-btn>
                    </v-col>
                    <v-col cols="auto">
                        <v-btn color="primary" @click="submit" :loading="submitBtnClicked" :disabled="submitting"
                            >Volgende</v-btn
                        >
                    </v-col>
                </v-row>
            </v-form>
        </application-stepper>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ApplicationStepper from '../components/ApplicationStepper';
import VErrorMessages from '@/components/VErrorMessages';
import VFloatField from '@/components/VFloatField';

export default {
    name: 'step7-expense',
    components: {
        ApplicationStepper,
        VErrorMessages,
        VFloatField,
    },
    data: () => ({
        errorDetails: {},
        loaded: false,
        backBtnClicked: false,
        submitBtnClicked: false,
        submitting: false,

        errorMessages: [],
        applicant: {
            expense: {
                rentMortgageAmount: null,
                cityTaxAmount: null,
                purificationChargesAmount: null,
                utilitiesAmount: null,
                waterAmount: null,
                healthInsuranceAmount: null,
                householdInsuranceAmount: null,
                liabilityInsuranceAmount: null,
                funeralInsuranceAmount: null,
                internetTvPhoneAmount: null,
                mobilePhoneAmount: null,
                otherAmount: null,
            },
        },
    }),
    computed: {
        ...mapGetters({ vuex: 'step7' }),
        applicantExpenseTotalAmount() {
            const applicantExpense = this.applicant.expense;
            const expenseTotal =
                applicantExpense.rentMortgageAmount +
                applicantExpense.cityTaxAmount +
                applicantExpense.purificationChargesAmount +
                applicantExpense.utilitiesAmount +
                applicantExpense.waterAmount +
                applicantExpense.healthInsuranceAmount +
                applicantExpense.householdInsuranceAmount +
                applicantExpense.liabilityInsuranceAmount +
                applicantExpense.funeralInsuranceAmount +
                applicantExpense.internetTvPhoneAmount +
                applicantExpense.mobilePhoneAmount +
                applicantExpense.otherAmount;
            return expenseTotal;
        },
    },
    created: function() {
        const that = this;

        this.step7Load().then(function() {
            that.applicant.expense.rentMortgageAmount = that.vuex.applicant.expense.rentMortgageAmount;
            that.applicant.expense.cityTaxAmount = that.vuex.applicant.expense.cityTaxAmount;
            that.applicant.expense.purificationChargesAmount = that.vuex.applicant.expense.purificationChargesAmount;
            that.applicant.expense.utilitiesAmount = that.vuex.applicant.expense.utilitiesAmount;
            that.applicant.expense.waterAmount = that.vuex.applicant.expense.waterAmount;
            that.applicant.expense.healthInsuranceAmount = that.vuex.applicant.expense.healthInsuranceAmount;
            that.applicant.expense.householdInsuranceAmount = that.vuex.applicant.expense.householdInsuranceAmount;
            that.applicant.expense.liabilityInsuranceAmount = that.vuex.applicant.expense.liabilityInsuranceAmount;
            that.applicant.expense.funeralInsuranceAmount = that.vuex.applicant.expense.funeralInsuranceAmount;
            that.applicant.expense.internetTvPhoneAmount = that.vuex.applicant.expense.internetTvPhoneAmount;
            that.applicant.expense.mobilePhoneAmount = that.vuex.applicant.expense.mobilePhoneAmount;
            that.applicant.expense.otherAmount = that.vuex.applicant.expense.otherAmount;

            that.loaded = true;
        });
    },
    methods: {
        ...mapActions(['step7Load', 'step7Submit']),
        back: function() {
            const that = this;
            this.backBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step7Submit(this.$data).finally(function() {
                that.$router.push({ name: 'step6_income' });
                that.backBtnClicked = false;
                that.submitting = false;
            });
        },
        submit: function() {
            const that = this;
            this.submitBtnClicked = true;
            this.submitting = true;
            this.errorMessages = [];

            this.step7Submit(this.$data)
                .then(function() {
                    that.$router.push({ name: 'step8_attachment' });
                })
                .catch(function(error) {
                    const response = error.response;
                    that.errorMessages = response.data.error.messages;
                    that.$vuetify.goTo(that.$refs.errorMessages, {
                        duration: 300,
                        offset: 100,
                        easing: 'easeInOutCubic',
                    });
                })
                .finally(function() {
                    that.submitBtnClicked = false;
                    that.submitting = false;
                });
        },
    },
};
</script>
